import { z } from 'zod';

export const SignatureTypeSchema = z.enum(['click', 'digital']);
export type SignatureType = z.infer<typeof SignatureTypeSchema>;

export const SignatureDataSchema = z.object({
  dataUrl: z.string().min(1),
});
export type SignatureData = z.infer<typeof SignatureDataSchema>;

export const PendingConsentSchema = z.object({
  document_id: z.string().uuid(),
  type: z.string().min(1),
  name: z.string().min(1),
  version_id: z.string().uuid(),
  version: z.string().min(1),
  content: z.string(),
  signature_type: SignatureTypeSchema,
  requires_signature: z.boolean(),
});
export type PendingConsent = z.infer<typeof PendingConsentSchema>;

export const PendingConsentsResponseSchema = z.object({
  pending: z.array(PendingConsentSchema),
});
export type PendingConsentsResponse = z.infer<typeof PendingConsentsResponseSchema>;

// Discriminated union: signature_data is required iff signature_type === 'digital'.
// Compile-time check that prevents the modal (or any future caller) from
// constructing a malformed payload.
export const AcceptConsentInputSchema = z.discriminatedUnion('signature_type', [
  z.object({
    version_id: z.string().uuid(),
    signature_type: z.literal('click'),
  }),
  z.object({
    version_id: z.string().uuid(),
    signature_type: z.literal('digital'),
    signature_data: SignatureDataSchema,
  }),
]);
export type AcceptConsentInput = z.infer<typeof AcceptConsentInputSchema>;

export const AcceptConsentResponseSchema = z.object({
  success: z.literal(true),
});
export type AcceptConsentResponse = z.infer<typeof AcceptConsentResponseSchema>;
